import React from "react";
import { Trash2, XCircle } from "lucide-react";

const bhkOptions = ["1 BHK", "2 BHK", "3 BHK", "4 BHK", "5 BHK+", "Studio"];


const FloorPricingDetails = ({ formData, handleChange, addFloor, removeFloor, handleFileChange, removeImage,handleCheckboxChange }) => {
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">Floor & Pricing Details</legend>

      {formData.floorPricingDetails.map((floor, index) => (
        <div key={index} className="border border-gray-300 p-4 rounded-md relative mb-4">
          
          {/* Delete Floor Button */}
          {index > 0 && (
            <button
              type="button"
              onClick={() => removeFloor(index)}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700"
            >
              <Trash2 size={20} />
            </button>
          )}

          <div className="grid grid-cols-2 gap-4">
            
            {/* Price Range */}
            <div>
              <label className="block text-gray-700 font-medium">Price Range</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  name="floorPriceMin"
                  value={floor.floorPriceMin}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Min Price"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  required
                />
                <input
                  type="text"
                  name="floorPriceMax"
                  value={floor.floorPriceMax}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Max Price"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
            </div>


            

            {/* Super Area Range */}
            <div className="flex gap-2">
              <div className="flex-1">
                <label className="block text-gray-700 font-medium">Super Area Range</label>
                <div className="flex gap-2">
                  <input
                    type="number"
                    name="superAreaMin"
                    value={floor.superAreaMin}
                    onChange={(e) => handleChange(e, index)}
                    placeholder="Min Sq-ft"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    required
                  />
                  <input
                    type="number"
                    name="superAreaMax"
                    value={floor.superAreaMax}
                    onChange={(e) => handleChange(e, index)}
                    placeholder="Max Sq-ft"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    required
                  />
                </div>
              </div>
              <div>
                <label className="block text-gray-700 font-medium">Unit</label>
                <select
                  name="superAreaUnit"
                  value={floor.superAreaUnit}
                  onChange={(e) => handleChange(e, index)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                >
                  <option value="Sq-ft">Sq-ft</option>
                  <option value="Sq-m">Sq-m</option>
                  <option value="Acre">Acre</option>
                </select>
              </div>
            </div>

          {/* BHK Type (✅ Added Dropdown Here) */}
          <div>
              <label className="block text-gray-700 font-medium">BHK Type</label>
              <select
                name="bhkType"
                value={floor.bhkType}
                onChange={(e) => handleChange(e, index)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="">Select BHK</option>
                {bhkOptions.map((bhk) => (
                  <option key={bhk} value={bhk}>
                    {bhk}
                  </option>
                ))}
              </select>
            </div>



            {/* Rent Range */}
            <div>
              <label className="block text-gray-700 font-medium">Estimated Rent</label>
              <div className="flex gap-2">
                <input
                  type="number"
                  name="estimatedRentMin"
                  value={floor.estimatedRentMin}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Min Rent"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
                <input
                  type="number"
                  name="estimatedRentMax"
                  value={floor.estimatedRentMax}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Max Rent"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
            </div>


 {/* EMI Available Checkbox EMI Input (Only Show if Checked)  */}
             <div className="col-span-2">
             <div className="flex items-center gap-2">
              <input
                type="checkbox"
                name="emiAvailable"
                checked={floor.emiAvailable}
                onChange={(e) => handleCheckboxChange(e, index)}
                className="w-5 h-5"
              />
              <label className="text-gray-700 font-medium">EMI Available</label>
            </div>

            {floor.emiAvailable && (
              <div>
                <label className="block text-gray-700 font-medium">EMI Amount</label>
                <input
                  type="number"
                  name="emiAmount"
                  value={floor.emiAmount}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="Enter EMI Amount"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
            )}
      </div>




            {/* Floor Type & Map Upload */}
            <div className="col-span-2">
              <label className="block text-gray-700 font-medium">Floor Type</label>
              <select
                name="floorType"
                value={floor.floorType}
                onChange={(e) => handleChange(e, index)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
              >
                <option value="Ground Floor">Ground Floor</option>
                <option value="First Floor">First Floor</option>
                <option value="Second Floor">Second Floor</option>
                <option value="Penthouse">Penthouse</option>
              </select>
              
              {/* Image Upload */}
              <input
                type="file"
                multiple
                name="floorMap"
                onChange={(e) => handleFileChange(e, index)}
                className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-md"
              />
              
              {/* Show Uploaded Images */}
              {floor.floorMap.length > 0 && (
                <div className="mt-2 grid grid-cols-3 gap-2">
                  {floor.floorMap.map((image, imgIndex) => (
                    <div key={imgIndex} className="relative">
                      <img src={URL.createObjectURL(image)} alt="Floor Map" className="w-full h-20 object-cover rounded-md" />
                      <button
                        type="button"
                        className="absolute top-1 right-1 bg-white p-1 rounded-full text-red-500 hover:text-red-700"
                        onClick={() => removeImage(index, imgIndex)}
                      >
                        <XCircle size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Number of Bathrooms & Balconies */}
            <div className="flex gap-2">
              <div>
                <label className="block text-gray-700 font-medium">Bathrooms</label>
                <input
                  type="number"
                  name="bathrooms"
                  value={floor.bathrooms}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="No. of Bathrooms"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium">Balconies</label>
                <input
                  type="number"
                  name="balconies"
                  value={floor.balconies}
                  onChange={(e) => handleChange(e, index)}
                  placeholder="No. of Balconies"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md"
                />
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Add Floor Button */}
      <button
        type="button"
        onClick={addFloor}
        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
      >
        + Add Floor
      </button>
    </fieldset>
  );
};

export default FloorPricingDetails;
